'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

exports.default = _arrayWithHoles;
//# sourceMappingURL=arrayWithHoles.js.map
